import { render } from "./safe.vue?vue&type=template&id=004c97e8&scoped=true"
import script from "./safe.vue?vue&type=script&lang=js"
export * from "./safe.vue?vue&type=script&lang=js"

import "./safe.vue?vue&type=style&index=0&id=004c97e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004c97e8"]])

export default __exports__